import { MagnetSeniorType } from '@libs/types/enum'

export const DPI_LEVEL_MAX = 5

export type KK = number & { __brand: 'KK' } // 键盘实际对应的按键值
export type VK = number & { __brand: 'VK' } // 按键功能值 https://learn.microsoft.com/en-us/windows/win32/inputdev/virtual-key-codes
export type LK = number & { __brand: 'LK' } // 键盘灯光对应的按键值
export type DVK = number & { __brand: 'VK' } // 设备对应的VK值
export type DefineDevice = number & { __brand: 'DefineDevice' }

export type KeyMap = [number, number, number, number]

export const ToReset: VK = 0 as VK

export const VirtualHE3SEWireless_24g: DefineDevice = 0x0c45c077 as DefineDevice
export const VirtualHE3SEWireless: DefineDevice = 0x0c450500 as DefineDevice
export const VirtualNa87ProWired: DefineDevice = 0x201c4fee88 as DefineDevice
export const VirtualNd63: DefineDevice = 0x301c4fee88 as DefineDevice
export const VirtualMu68Pro: DefineDevice = 0x101c4fee88 as DefineDevice
export const VirtualMu68Pro_Cyan: DefineDevice = 0x111c4fee88 as DefineDevice
export const VirtualMu68_ULTRA: DefineDevice = 0x121c4fee88 as DefineDevice
export const VirtualNd63_Cyan: DefineDevice = 0x311c4fee88 as DefineDevice

// export const VirtualPolar75: DefineDevice = 0x401c4fee88 as DefineDevice;
export const VirtualPolar75: DefineDevice = 0x401ca30201 as DefineDevice

export const VirtualMars68ProWireless: DefineDevice = 0x31515030 as DefineDevice
export const VirtualMars68ProWireless_24g: DefineDevice = 0x3151502b as DefineDevice
export const VirtualMars68Pro: DefineDevice = 0x3031515029 as DefineDevice

export const VirtualMars68SE: DefineDevice = 0x1031515029 as DefineDevice
export const VirtualMars68: DefineDevice = 0x2031515029 as DefineDevice

export const VirtualMars68Wireless: DefineDevice = 0x4031515030 as DefineDevice
export const VirtualMars68Wireless_24g: DefineDevice = 0x31515026 as DefineDevice

export const VirtualMonsGeek: DefineDevice = 0x3151502d as DefineDevice
export const VirtualMonsGeek_NoLight: DefineDevice = 0x3151502e as DefineDevice
export const VirtualMonsGeek_NoLight_24g: DefineDevice = 0x31514011 as DefineDevice

export const VirtualMg68: DefineDevice = 0x103151502d as DefineDevice
export const VirtualMg68SE: DefineDevice = 0x203151502d as DefineDevice
export const VirtualMg68Pro: DefineDevice = 0x303151502d as DefineDevice
export const VirtualMg68Lite: DefineDevice = 0x403151502d as DefineDevice
export const VirtualMG68ACE: DefineDevice = 0x5031515029 as DefineDevice
export const VirtualMG68ACE_UpPlus: DefineDevice = 0x5131515029 as DefineDevice
export const VirtualMG68ACE_W: DefineDevice = 0x5131515030 as DefineDevice
export const VirtualMG68ACE_W_24g: DefineDevice = 0x5231515038 as DefineDevice
export const VirtualMg68Max: DefineDevice = 0x3151502f as DefineDevice
export const VirtualMg68Max_24g: DefineDevice = 0x103151502b as DefineDevice

export const VirtualMg75: DefineDevice = 0x101ca50807 as DefineDevice
export const VirtualMg75Pro: DefineDevice = 0x201ca50807 as DefineDevice

export const VirtualMer68: DefineDevice = 0x101ca50806 as DefineDevice
export const VirtualMer68Pro: DefineDevice = 0x111ca50806 as DefineDevice
export const VirtualMer68SE: DefineDevice = 0x4031515029 as DefineDevice
export const VirtualMer68Lite: DefineDevice = 0x4131515029 as DefineDevice
export const VirtualMer68Max: DefineDevice = 0x1ca6052d as DefineDevice // 0.001

export const VirtualHe6Ultra: DefineDevice = 0x3554fb36 as DefineDevice
export const VirtualHe6Ultra_24g: DefineDevice = 0x3554fb35 as DefineDevice

//jingtai v2
export const VirtualMg75Max: DefineDevice = 0x1ca60529 as DefineDevice
export const VirtualMg68Plus: DefineDevice = 0x1ca6052a as DefineDevice
export const VirtualMars75: DefineDevice = 0x1ca6052b as DefineDevice
export const VirtualMars75Pro: DefineDevice = 0x101ca6052b as DefineDevice

// royuan
export const VirtualND68: DefineDevice = 0x31515029 as DefineDevice
export const VirtualND63Max: DefineDevice = 0x603151502d as DefineDevice

// jingtai
export const VirtualND68Pro: DefineDevice = 0x1ca6052c as DefineDevice
export const VirtualND63Ultra: DefineDevice = 0x1ca60531 as DefineDevice

export const VirtualRA68: DefineDevice = 0x1ca60528 as DefineDevice

// fe87v2
export const VirtualIrokFe87V2: DefineDevice = 0x19bf1020 as DefineDevice
export const VirtualIrokFe87V2_24g: DefineDevice = 0x1a868300 as DefineDevice
export const VirtualIrokFe87V2IMC: DefineDevice = 0x19bf1030 as DefineDevice
export const VirtualIrokFe87V2IMC_24g: DefineDevice = 0x101a868300 as DefineDevice
export const Fe87v2Devices: DefineDevice[] = [VirtualIrokFe87V2, VirtualIrokFe87V2_24g, VirtualIrokFe87V2IMC, VirtualIrokFe87V2IMC_24g]
export const VirtualMer68SESelfDev: DefineDevice = 0x19bf1010 as DefineDevice

// 火柴人
export const VirtualMG63: DefineDevice = 0x2f813004 as DefineDevice
export const VirtualRA68_1: DefineDevice = 0x2f813005 as DefineDevice
export const VirtualMG75V2C12: DefineDevice = 0x2f813007 as DefineDevice
export const HuoChaiRenDevices: DefineDevice[] = [VirtualMG63, VirtualRA68_1, VirtualMG75V2C12]

export const VirtualFE87V2_MuYan: DefineDevice = 0x28e9320e as DefineDevice
export const ZhiHuiWuXian_Device: DefineDevice[] = [VirtualFE87V2_MuYan]

export const JingTaiMg75Devices: DefineDevice[] = [VirtualMg75, VirtualMg75Pro]
export const JingTaiMer68Devices: DefineDevice[] = [
  VirtualMer68, //  JingTai
  VirtualMer68Pro, //
]

const RoYuanMer68Device: DefineDevice[] = [VirtualMer68SE, VirtualMer68Lite]
const RoYuanMg68Device: DefineDevice[] = [VirtualMg68, VirtualMg68SE, VirtualMg68Pro, VirtualMg68Max, VirtualMg68Max_24g, VirtualMg68Lite, VirtualMG68ACE, VirtualMG68ACE_UpPlus, VirtualMG68ACE_W, VirtualMG68ACE_W_24g]
const RoYuanMars68Device: DefineDevice[] = [VirtualMars68SE, VirtualMars68, VirtualMars68Wireless, VirtualMars68Wireless_24g, VirtualMars68ProWireless, VirtualMars68ProWireless_24g, VirtualMars68Pro]
const RoYuanMonsGeekDevice: DefineDevice[] = [VirtualMonsGeek, VirtualMonsGeek_NoLight, VirtualMonsGeek_NoLight_24g]
const RoYuanND68Device: DefineDevice[] = [VirtualND68]
const RoYuanND63Device: DefineDevice[] = [VirtualND63Max]
export const RoYuanDevice: DefineDevice[] = [...RoYuanMars68Device, ...RoYuanMonsGeekDevice, ...RoYuanMg68Device, ...RoYuanMer68Device, ...RoYuanND68Device, ...RoYuanND63Device]
// 0.001
export const JingTaiV2Devices: DefineDevice[] = [VirtualMg68Plus, VirtualMg75Max, VirtualMars75, VirtualMars75Pro, VirtualND68Pro, VirtualND63Ultra, VirtualMer68Max, VirtualRA68]

export type KeyCode = [number, number, number?] // KeyCode 可能为空，第三个元素是可选的
export type KeyFunction = [number, number, number, number] // 固定长度为 4 的数组

interface SetMagnetKey {
  KeyCode: KeyCode // 表示组合按键
  KeyFunction: KeyFunction // 表示功能类型
  Travel: number // 表示行程值
}

export interface SetMagnetSenior {
  KeyType: MagnetSeniorType
  Keys: [SetMagnetKey, SetMagnetKey, SetMagnetKey, SetMagnetKey]
  MTDuration: number //< 按住功能时的按压时间,长按时间（150~1000ms ）;
  TGLEnable: number //< 0关闭(0时keycode应该为空)  1开启   (按一下按键一直发码，再按一下停止);
  TGLMode: number //royuan方案增加TGL 两种播放方式： TGL = 4(长按)，TGL = 5(连点)
  KMEMode: [number, number]
  DelayTime: 0
}

export interface DataTravel {
  PressNum: number //第1个条的数值
  ReleaseNum: number //第1个条的数值
  QuickTriggerPressNum: number //第2个条的数值 如果没有填0
  QuickTriggerReleaseNum: number //第3个条的数值 如果没有填0
}

export interface Record {
  Key: VK
  Press: boolean
  Delay: number
}

export interface Layout {
  KeyMap: Map<KK, number>
  KeyMapModifier: Map<KK, number[]>
  Magenet: Map<KK, SetMagnetSenior>
  // KeyMedia: Map<KK, number>;
  // KeyMouse: Map<KK, number>;
  KeyMapFire: Map<KK, number[]>
  Macros: Map<KK, Record[]>
  MacroType: Map<KK, MacroType>
}

export interface MacroType {
  LoopType: number
  LoopTimes: number
}

export interface KIO {
  Input: Input
  Output: Output
}

export interface Input {
  KK: KK
  WithFN: boolean
  WithModifier: VK[]
}

export interface Output {
  Mode: OutputMode //按键(键盘,鼠标,多媒体)/宏/磁轴
  VK: VK //按键 - 键盘,鼠标,多媒体
  DataIndex: number //数据的存储索引, 宏的索引, 磁轴数据的索引
  Extension: number[] // 宏扩展
}

export enum OutputMode {
  Key = 0,
  Macro = 1,
  Magnet = 2,
  Fire = 3,
}
